<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} Công ty lữ hành
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên công ty">
                      <el-input v-model="mData.tableRules.dataSearch.value['ten.vi']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Email">
                      <el-input v-model="mData.tableRules.dataSearch.value.email" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Điện thoại">
                      <el-input
                        type="number"
                        v-model="mData.tableRules.dataSearch.value.dien_thoai"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Website">
                      <el-input v-model="mData.tableRules.dataSearch.value.website" clearable></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                plain
                v-if="aRole('Admin')"
              >{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          default-expand-all
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="20" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="isDisabled"
            :sortable="mData.tableRules.allowSorting"
            label="Khóa"
            width="80"
            align="center"
            v-if="aRole('Admin,Officer')"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.isDisabled"
                @change="fn_changeTrangThaiKhoa(scope.row.id, scope.row.isDisabled)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten.vi"
            :sortable="mData.tableRules.allowSorting"
            label="Tên công ty"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ten.vi}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            :sortable="mData.tableRules.allowSorting"
            label="Email"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="dien_thoai"
            :sortable="mData.tableRules.allowSorting"
            label="Điện thoại"
            width="120"
            align="right"
          ></el-table-column>
          <el-table-column
            prop="website"
            :sortable="mData.tableRules.allowSorting"
            label="Website"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="dia_chi.dia_chi"
            :sortable="mData.tableRules.allowSorting"
            label="Địa chỉ"
            width="150"
          ></el-table-column>

          <el-table-column
            prop="so_sao"
            :sortable="mData.tableRules.allowSorting"
            label="Đánh giá"
            align="center"
          >
            <template slot-scope="scope" v-if="scope.row.so_sao && scope.row.luot_danh_gia">
              <p style="margin-bottom: 3px;">
                {{scope.row.so_sao}}
                <i
                  v-show="scope.row.so_sao > 0 && scope.row.so_sao != null"
                  class="el-icon-star-on"
                  style="color: #0373fc;"
                ></i>
              </p>
              <p style="margin-bottom: 0;">
                {{fn_changeNumber(scope.row.luot_danh_gia)}}
                <span
                  v-show="scope.row.luot_danh_gia > 0 && scope.row.luot_danh_gia != null"
                >đánh giá</span>
              </p>
            </template>
          </el-table-column>

          <el-table-column
            :label="aLang.c_action"
            align="center"
            width="120"
            v-if="aRole('Admin,Officer,TourAgent')"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                v-if="aRole('Admin,TourAgent')"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import CongTyLuHanhModel from "./CongTyLuHanhModel";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "CongTyLuHanh", //requied
        tableRules: MethodService.copyObject(CongTyLuHanhModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          trangThai: MethodService.copyObject(CongTyLuHanhModel.trangThai)
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      if (MethodService.checkRole("TourAgent")) {
        this.mData.tableRules.filters = "id=$$cong_ty_lu_hanh_id";
      }
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }
      console.log(dataFilter);

      let res = await CongTyLuHanhApi.list(dataFilter);
      let resDanhGia = await CongTyLuHanhApi.countDanhGia();
      if (resDanhGia.result) {
        res.result.forEach(item => {
          let saodanhgia = resDanhGia.result.find(
            danhgia => danhgia.cong_ty_lu_hanh_id == item.id
          );
          if (saodanhgia) {
            item["so_sao"] = parseFloat(
              saodanhgia.tong_sao / saodanhgia.tong_so_tour
            ).toFixed(1);
            item["luot_danh_gia"] = saodanhgia.tong_so_tour;
          }
        });
      }
      this.mData.tableRules.data = res.result;

      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    async fn_changeTrangThaiKhoa(id, trangThai) {
      let data = {
        id: id,
        isDisabled: trangThai
      };
      if (trangThai) {
        await CongTyLuHanhApi.updateLock(data);
      } else {
        await CongTyLuHanhApi.updateUnLock(data);
      }

      this.fn_initTable();
    },

    async fn_changeTrangThai(command) {
      let data = {
        id: command.id,
        isDisabled: command.trangThaiNew
      };
      await CongTyLuHanhApi.update(data);
      this.fn_initTable();
    },
    //thêm trangThaiNew vào object
    fn_mergeTrangThai(row, status) {
      let object = MethodService.copyObject(row);
      object.trangThaiNew = status;
      return object;
    },

    //delete
    async fn_delete(id) {
      await CongTyLuHanhApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await CongTyLuHanhApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value['ten.vi']){
        this.mData.tableRules.dataSearch.value['ten.vi']= this.mData.tableRules.dataSearch.value['ten.vi'].trim();
      }
      if(this.mData.tableRules.dataSearch.value.email){
        this.mData.tableRules.dataSearch.value.email = this.mData.tableRules.dataSearch.value.email.trim();
      }
      if(this.mData.tableRules.dataSearch.value.dien_thoai){
        this.mData.tableRules.dataSearch.value.dien_thoai = this.mData.tableRules.dataSearch.value.dien_thoai.trim();
      }                
      if(this.mData.tableRules.dataSearch.value.website){
        this.mData.tableRules.dataSearch.value.website = this.mData.tableRules.dataSearch.value.website.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_changeNumber(number) {
      return MethodService.changeNumberToString(number);
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
